import { render, staticRenderFns } from "./IconBrandLogoFavicon.vue?vue&type=template&id=6986a7d7&"
import script from "./IconBrandLogoFavicon.vue?vue&type=script&lang=js&"
export * from "./IconBrandLogoFavicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports